import ApiClient from './ApiClient';

class ImportantMessagesAPI extends ApiClient {
  constructor() {
    super('important_messages', { accountScoped: true });
  }

  getUnread() {
    return axios.get(this.url);
  }

  markAsRead(id) {
    return axios.post(`${this.url}/${id}/read`);
  }
}

export default new ImportantMessagesAPI();
